import React, { FC, useState, Fragment, useRef, useEffect, useMemo, useLayoutEffect } from 'react'
import { IonPage, IonContent, IonFooter, useIonViewWillEnter, IonSpinner } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { memberMobx, payMobx, timePickMobx, themeMobx, multiPersonOrderingMobx, buyTogetherMobx } from '@mobxStore'
import { restaurantCenter, restaurantConfig, orderMobx, storeMobx, cartMobx, productMobx } from 'restaurant'
import { PhoneModal, BagIcon, GroupBuyStatus } from 'components'
import { TipModal, Advert as MenuAdvert, Icon, ProductImage } from '@cps'
import CheckoutPayController from '@ctrls/checkoutPayController'
import { store, classNames, format, uuid, ddayjs, toPriceLittleCurrency } from '@dt/fe-utils'
import { loadingLayer, getEnv, modalLayer, useHistoryNew, toast, getCouponsInfo, setDocumentTitle, getPlatform } from '@utils'
import { RestoreOrderController, WxLocationController, MktController, WxpayGoldPlanController, OrdersController, CashierController } from '@ctrls/index'
import orderAPI from '@api/order.api'
import ActivityApi from '@api/activity.api'
import KitchenAPI from '@api/kitchen.api'
import MemberApi from '@api/member.api'
import { groupBy, keyBy, map, each, maxBy, forEach, sumBy, values, minBy, filter, uniqBy, flatMap } from '@dt/fe-utils/dist/lodash'
import JsBarcode from 'jsbarcode'
import { ResultMall, TableInput, DetailItem, RefundBar, GroupBuyBox } from './components'
import { handleShareForWxa } from '@common/utils/share'
import { ExpressPriceModal } from './modal'
import StoreAPI from '@api/store.api'
import WaitingOrderBar from './components/WaitingOrderBar'
import { TEOrderStatus, TEOrdersRefundStatus, TEOrdersType } from '@common/enum/order.enum'
import { refundMobx } from '@mobx/order'
import './index.scss'

import randomBoxImg from '@img/mkt/groupBuy/randomBoxTypeImg.png'
import luckyBagImg from '@img/mkt/groupBuy/luckyBagTypeImg.png'
import ENV from '@env'

interface IProps extends RouteComponentProps {
}

let initCnt = 0
let st: any = null

const reason = {
  'Success': 'result.orderSuccess',
  'Pending': 'result.resultPending',
  'Paying': 'result.resultPending',
  'Timeout': 'result.orderCancel',
  'Cancel': 'result.orderCancel'
}

const tips = {
  'Success': '',
  'Pending': '',
  'Paying': '',
  'Timeout': 'result.errorTips',
  'Cancel': 'result.errorTips'
}

const iconStatus = {
  'Success': 'icon-checkmark--outline',
  'Pending': 'icon-time2x',
  'Paying': 'icon-time2x',
  'Timeout': 'icon-dengdai',
  'Cancel': 'icon-dengdai'
}

const iconMakeStatus = {
  'order': 'icon-jiedan',
  'fetch': 'icon-wancheng',
  'make': 'icon-zhizuozhong1',
  // '已完成': 'icon-kequcan',
  'send': 'icon-wancheng',
  'arrived': 'icon-wancheng',
  'sending': window.bo === 'cn' ? 'icon-delivery-result-cn' : 'icon-delivery-result-us',
  'selfsending': window.bo === 'cn' ? 'icon-delivery-result-cn' : 'icon-delivery-result-us',
  'paid': 'icon-zhifuwancheng',
}

const { toPrice, toDate, toTime, toDateTime } = format

const Result: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { id } = match.params as any
  const barcodeRef = useRef<any>(null)
  const [isCheckPay, setIsCheckPay] = useState(true)
  const [showFooter, setShowFooter] = useState(true)
  const [showMoreProduct, setShowMoreProduct] = useState(false) // 显示全部餐品
  const [showMorePrice, setShowMorePrice] = useState(true) // 显示全部价格明细
  const [toMember, setToMember] = useState(true)
  const [openInGoldPlan, setOpenInGoldPlan] = useState(false)
  const [receiveCouponCnt, setReceiveCouponCnt] = useState(0)
  const [cabinetCode, setCabinetCode] = useState<string>('')
  const [goldPlanBackUrl, setGoldPlanBackUrl] = useState<string>('')
  const [showGroupBuyBag, setShowGroupBuyBag] = useState(true) // 显示团购券
  /** 团购券是否可退款 */
  const [canRefundGoods, setCanRefundGoods] = useState(true)
  const contentRef = useRef(null)
  const [userInfo, setUserInfo] = useState({
    type: 'mobile',
    value: ''
  })
  const [contactInfo, setContactInfo] = useState({}) as any
  const [couponMap, setCouponMap] = useState({})
  const [deliveryMapUrl, setDeliveryMapUrl] = useState('')
  const [mealWaitingTime, setMealWaitingTime] = useState<IMealsWaitingTime>({
    waitingTime: 0,
    orderUnMealedNum: 0,
    leastTime: 0,
    scene: {}
  })
  const [loadingWaiting, setLoadingWaiting] = useState<boolean>(false)
  const [statusGroups, setStatusGroups] = useState<{
    key: string;
    startTime: string;
    timeStr: string;
    productsStr: string;
    currentStatusIndex: number;
    deliverInfo?: IDeliveryInvoiceInfo;
  }[]>([])
  const [cardBalance, setCardBalance] = useState<{
    balanceAfter: number;
    balanceBefore: number;
    balanceChange: number;
  }>()
  const { refundConfig: { eatType: eatTypes } } = refundMobx
  const viewOrder = orderMobx.viewOrder
  const viewDetailList = orderMobx.viewDetailList
  const canRefundType = ['memberCardBuy', 'memberCardRenew', 'redeemCouponByMoney']
  const hasHome = themeMobx?.showTabs?.find(item => item.type === 'home')
  const { eatType, statusShowName, diningMode, contactName, contactMobile, deliverInfo } = viewOrder
  const { isWeixinMiniProgram } = getPlatform()

  /** 展示团购券抽奖动画 */
  const showGroupBuyAnimate = useMemo(() => {
    const { eatType, ordersType } = orderMobx.viewOrder
    return ordersType === 'goods' && eatType === 'redeemCouponByMoney' && !history.getPrevState() && !!orderMobx.viewDetailList?.[0]?.activityType && !!Object.keys(couponMap).length && showGroupBuyBag
  }, [orderMobx.viewDetailList, couponMap, showGroupBuyBag])

  /** 判断可以退款, 展示退款按钮 */
  const canRefund = useMemo(() => {
    return (viewOrder.ordersType === TEOrdersType.dc && viewOrder.status === TEOrderStatus.Success && !viewOrder.refundTime && eatTypes.includes(viewOrder.eatType) && (viewOrder?.startTime && ddayjs(viewOrder?.startTime).valueOf() > ddayjs().valueOf()))
  }, [statusGroups, eatTypes, viewOrder])

  /** 当前是拼单 */
  const isBuyTogether = useMemo(() => {
    return [viewOrder.channel, viewOrder.sourceType].includes('buyTogether')
  }, [viewOrder.sourceType])

  // 未支付完全去pos支付
  const isErrPayForPos = useMemo(() => (viewOrder.ordersType === 'dc' && viewOrder.status === 'Paying' && viewOrder.paymentList.length > 0), [viewOrder])
  // 不分支付后剩余需要支付的钱
  const lastPayment = useMemo(() => {
    let payment = 0
    forEach(viewOrder.paymentList, (item, key) => {
      if (item.channelType[item.payType]?.ext?.received) {
        payment += parseFloat(item.channelType[item.payType].ext.received)
      }
    })
    return toPriceLittleCurrency(viewOrder.totalPrice - payment)
  }, [viewOrder])

  /** 活动商品图片 */
  const activityProductImg = (activityType: string) => {
    let pic = ''
    switch (activityType) {
      case 'randomBox':
        pic = randomBoxImg
        break
      case 'luckyBag':
        pic = luckyBagImg
        break
      default:
        break
    }
    return pic ? <ProductImage width={64} imgSrc={pic} className='product-img' /> : null
  }

  /**
   * 获取餐品制作时间
   */
  const getMealsWaitingTime = async () => {
    if (loadingWaiting) return
    setLoadingWaiting(true)
    try {
      const res = await StoreAPI.getMealsWaitingTime(viewOrder.storeId, viewOrder.brandId, id || viewOrder.ordersId)
      setMealWaitingTime(res)
    } catch (error) {
    }
    setLoadingWaiting(false)
  }

  /**
   * 预约时间
   */
  const _getTimeText = (startTime: string, pickTimeRange: string) => {
    const index = Number(ddayjs(startTime).format('YYYYMMDD') || '') - Number(ddayjs().format('YYYYMMDD') || '')
    const date = index >= 1 ? `${toDate(startTime)} ` : ''
    if (pickTimeRange) {
      try {
        const pickTimeRangeObj = JSON.parse(pickTimeRange) || {}
        if (pickTimeRangeObj?.start) {
          const start = ddayjs(pickTimeRangeObj.start).valueOf()
          const end = ddayjs(pickTimeRangeObj.end).valueOf()
          return `${date}${toTime(start)}-${toTime(end)}`
        }
      } catch (error) {
      }
    }
    return `${date}${toTime(ddayjs(startTime, 'client').valueOf())}`
  }

  /**
   * 获取预约时间，或者时段起始时间
   */
  const _getStartTime = (startTime: string, pickTimeRange: string) => {
    const index = Number(ddayjs(startTime).format('YYYYMMDD') || '') - Number(ddayjs().format('YYYYMMDD') || '')
    const date = index >= 1 ? `${toDate(startTime)} ` : ''
    if (pickTimeRange) {
      try {
        const pickTimeRangeObj = JSON.parse(pickTimeRange) || {}
        if (pickTimeRangeObj?.start) {
          return pickTimeRangeObj?.start
        }
      } catch (error) {
      }
    }
    return startTime
  }

  /**
   * 跳转路由
   */
  const handleGo = (path) => {
    if (WxpayGoldPlanController.isOpen()) {
      WxpayGoldPlanController.goPath(path, orderMobx.viewOrder)
    } else {
      history.replace(path)
    }
  }

  const sendMsg = () => {
    setShowFooter(false)
    modalLayer(PhoneModal, {}, 'phoneModal').then((res: any) => {
      if (res) {
        setUserInfo({
          type: res.type,
          value: res.value
        })
        orderMobx.sendMsgToCustom(viewOrder.ordersId, res.value, res.type).then((res: any) => {
          if (res.result.register) {
            setToMember(false)
          } else {
            // 防止第一次会员，第二次非会员
            setToMember(true)
          }
          setShowFooter(true)
        })
      }
    }).catch(() => {
      setShowFooter(true)
    })
  }

  // 获取优惠券详情
  const getCouponDetails = async (ids: any, brandId?: number) => {
    const res = await ActivityApi.getCouponsList({ couponIds: ids, brandId })
    if (res?.length > 0) {
      setCouponMap(keyBy(res, 'couponId'))
    }
  }

  /**
   * 餐品级状态
   */
  const getStatusGroups = () => {
    let groups = []
    const expressGroups = groupBy(orderMobx.viewOrder?.expressList, 'deliveryTime')
    each(groupBy(orderMobx.viewDetailList, d => d?.pickTimeRange || d?.startTime), (items: IViewOrderDetail[], key: string) => {
      const text = items[0]?.name
      const cnt = items?.reduce((prv: number, item) => {
        return prv + (item?.cnt || 1)
      }, 0)
      const deliveryTime = items?.[0]?.deliveryTime
      const _startTime = items?.[0]?.startTime
      const pickTimeRange = key && _startTime && key !== _startTime ? key : ''
      const startTime = _getStartTime(_startTime, pickTimeRange)
      const currentStatusIndex = minBy(items, 'currentStatusIndex')?.currentStatusIndex || 0
      groups.push({
        key,
        startTime: startTime,
        timeStr: _getTimeText(startTime, pickTimeRange),
        productsStr: text && cnt > 1 ? i18n.t('result.makeStatusGroupProduct', { text, cnt }) : text,
        currentStatusIndex,
        isFinish: statusShowName?.length - 1 >= currentStatusIndex ? 1 : 0, // 餐品状态终结状态
        deliverInfo: expressGroups?.[deliveryTime],
      })
    })
    groups = groups.sort((a, b) => ddayjs(a.startTime).valueOf() - ddayjs(b.startTime).valueOf())
    groups = groups.sort((a, b) => b.isFinish - a.isFinish)
    setStatusGroups(groups)
  }

  /**
   * 获取订单数据
   */

  const initOrder = (info, orderNo: string, brandId: number, fromGoldPlan: boolean, delayMs: number) => {
    initCnt += 1
    if (orderMobx.viewOrder.status === 'Paying' || orderMobx.viewOrder.status === 'Pending') {
      if (initCnt < 4) {
        st = setTimeout(() => getDelayOrder(orderNo, brandId, fromGoldPlan), delayMs)
      } else {
        setIsCheckPay(false)
      }
    } else {
      setIsCheckPay(false)
      if (orderMobx.viewOrder.status === 'Success') {
        /** 点餐类型才需要清除，充值回来还原购物车不能清除 */
        info.ordersType === 'dc' && cartMobx.clearPart({ remark: '', startTime: null, ordersId: '', managerDiscount: null })
        timePickMobx.reset()
      }
      CheckoutPayController.clearHoldAsync(orderNo)
    }

    // 获取优惠券详情
    if (info.eatType && info.eatType === 'redeemCouponByMoney') {
      let coupons = info.details[0].coupons || []
      if (!info.details?.[0]?.coupons?.length) {
        coupons = []
        forEach(orderMobx.viewDetailList, item => {
          if (item.coupons?.length) {
            coupons = uniqBy(flatMap(item.coupons, 'coupons'), 'couponId') || []
          }
        })
      }
      setCanRefundGoods(info.details?.[0]?.isRefund !== false)
      getCouponDetails(map(coupons, (item) => item.couponId))
    }
    // 获取消费送券
    if (info.ordersType === 'dc' && !WxpayGoldPlanController.isOpen()) {
      getCheckReceiveCoupon()
    }
    // 充值订单余额
    if (info.ordersType === 'cz') {
      getMemeberCardBalance()
    }
    // 订单餐品状态
    getStatusGroups()
    // 外卖收货信息
    try {
      setContactInfo(JSON.parse(info.contactInfo))
    } catch (error) {
    }
    // 返回路径
    if ((history.getPrevState().includes('paypalreturn') || history.getPrevState() === '') && keyBy(info.extList, 'attrName')?.mobilePayBackJumb) {
      const prePathInfo = JSON.parse(keyBy(info.extList, 'attrName')?.mobilePayBackJumb.attrValue)
      setGoldPlanBackUrl(prePathInfo.path)
      if (prePathInfo?.eatType) {
        CashierController.switchEatType(prePathInfo.eatType)
      }
      prePathInfo?.channel && productMobx.setChannel(prePathInfo.channel)
      prePathInfo?.storeId && storeMobx.initInfo(storeMobx.viewStoreList.find(s => s.storeId === prePathInfo.storeId))
    }
  }

  const getOrderDetail = (_order: IOrder, orderNo: string, brandId: number, fromGoldPlan: boolean) => {
    const order = orderMobx.initToDetail(_order)
    let delayMs = 300
    if (CheckoutPayController.isOrderAsync(orderNo)) {
      delayMs = 2000
      const { isDev } = getEnv()
      if (ENV.envBo === 'cn' || ENV.env === 'test' || isDev) {
        delayMs = 10000
      }
    }
    initOrder(order, orderNo, brandId, fromGoldPlan, delayMs)
  }

  const getDelayOrder = (orderNo: string, brandId?: number, fromGoldPlan?: boolean) => {
    let delayMs = 300
    if (CheckoutPayController.isOrderAsync(orderNo)) {
      delayMs = 2000
      const { isDev } = getEnv()
      if (ENV.envBo === 'cn' || ENV.env === 'test' || isDev) {
        delayMs = 10000
      }
    }
    orderMobx.init(orderNo, { fromGoldPlan, brandId, showMember: memberMobx?.isLogin ? 1 : 0 }).then((info) => {
      initOrder(info, orderNo, brandId, fromGoldPlan, delayMs)
    }).catch((err: any) => {
      console.log(err)
    })
  }

  /**
   * 成为会员
   */
  const toBeMember = () => {
    handleGo(`/login/password/0/${userInfo.type}/${userInfo.value}/${bo === 'us' ? 1 : 86}`)
  }

  /**
   * 返回
   */
  const backToPage = () => {
    if (Config.buyTogetherId) {
      location.href = `/menu?ct=brand&b=${Config.BRANDID}&s=${Config.STOREID || 0}`
      if (orderMobx.order?.status === 'Success') {
        buyTogetherMobx.delStorage()
        multiPersonOrderingMobx.delMultiRoom()
      }
    } else {
      // 有可能是异步支付直接跳转过来的，返回需要回到menu
      if (history.getPrevState().includes('paypalreturn') || history.getPrevState() === '') {
        if (goldPlanBackUrl && goldPlanBackUrl === '/checkout') {
          const prePathInfo = JSON.parse(keyBy(viewOrder.extList, 'attrName')?.mobilePayBackJumb.attrValue)
          if (WxpayGoldPlanController.isOpen()) {
            WxpayGoldPlanController.goPath('/menu', orderMobx.viewOrder, { source: 'checkout', s: prePathInfo.storeId, et: prePathInfo.eatType, cn: prePathInfo.channel, ct: prePathInfo.codeType || 'brand' })
          } else {
            history.replace('/menu', null, { ct: prePathInfo.codeType || 'brand', s: `${prePathInfo.storeId}`, source: 'checkout' })
          }
        } else {
          handleGo(goldPlanBackUrl || `/${hasHome ? 'home' : 'menu'}`)
        }
      } else {
        history.goBack()
      }
    }
  }

  /**
   * 订单退款
   */
  const getRefund = () => {
    modalLayer(TipModal, {
      title: i18n.t('result.refund'),
      content: i18n.t('result.refundTip', { orderNo: `#${viewOrder.nono || viewOrder.ordersId}`, orderName: '' }),
      btnType: 'choice',
      okText: i18n.t('common.ok')
    }).then(() => {
      loadingLayer.show()
      orderAPI.refund({
        requestId: uuid(),
        ordersId: viewOrder.ordersId,
        channel: viewOrder.channel,
        eatType: viewOrder.eatType,
        ordersType: viewOrder.ordersType
      }).then((res) => {
        toast({ message: i18n.t('result.refundSucc') })
        getDelayOrder(viewOrder.ordersId)
      }).catch((res) => {
        if (res.error) {
          let text: string = ''
          if (res.code === 5023) {
            text = i18n.t('result.refundFailed1')
          } else if (res.code === 1000) {
            text = i18n.t('result.refundFailed2')
          } else if (res.code === 5022) {
            text = i18n.t('result.refundFailed3')
          } else if (res.code === 5006) {
            text = i18n.t('result.refundFailed4')
          } else if (res.code === 5015) {
            text = i18n.t('result.refundFailed5')
          } else if (res.code === 5024) {
            text = i18n.t('result.refundFailed6')
          } else if (res.code === 5025) {
            text = i18n.t('result.refundFailed7')
          } else if (res.code === 5026) {
            text = i18n.t('result.refundFailed8')
          } else {
            text = i18n.t('result.refundFailed')
          }
          toast({ message: text })
        }
      }).finally(() => {
        contentRef.current && contentRef.current.scrollToTop()
        loadingLayer.hide()
      })
    }).catch(() => { })
  }

  const getCheckReceiveCoupon = () => {
    orderMobx.checkConsumeSendCoupon(id).then((res) => {
      if (res.length) {
        setReceiveCouponCnt(getCouponsInfo(res[0].coupons, 'cnt'))
      } else {
        setReceiveCouponCnt(0)
      }
    })
  }

  /**
   * 获取会员卡信息
   */
  const getMemeberCardBalance = () => {
    MemberApi.getMemeberCardOrderBalance({
      ordersId: id
    }).then((res: any) => {
      setCardBalance(res)
      memberMobx.setCardInfo({ ...memberMobx.cardInfo, balance: res.balanceAfter })
    })
  }

  const handleMapOpen = () => {
    WxLocationController.init()
  }

  useLayoutEffect(() => {
    if (WxpayGoldPlanController.isOpen()) {
      window.bo = 'cn'
      restaurantCenter.setConfig({
        bo: 'cn'
      })
      WxpayGoldPlanController.init()
      window.bo = 'cn'
      restaurantCenter.setConfig({
        bo: 'cn'
      })
      setOpenInGoldPlan(true)
    }
  }, [])

  useIonViewWillEnter(() => {
    initCnt = 0
    if (WxpayGoldPlanController.isOpen()) {
      window.bo = 'cn'
      restaurantCenter.setConfig({
        bo: 'cn'
      })
      WxpayGoldPlanController.init()
      window.bo = 'cn'
      restaurantCenter.setConfig({
        bo: 'cn'
      })
      WxpayGoldPlanController.getOrderInfo().then((res: any) => {
        restaurantCenter.setConfig({
          brandId: res.brandId
        })
        storeMobx.initList()
        getOrderDetail(res, res.ordersId, res.brandId, true)
        // getDelayOrder(res.ordersId, res.brandId, true)
      })
      setOpenInGoldPlan(true)
    } else {
      const state: any = history.location.state
      if (state?.fromList) {
        setDocumentTitle(i18n.t('checkout.orderDetail'))
      }
      getDelayOrder(id)
    }
    RestoreOrderController.setOrderEnterTableFlag()
  })

  /**
   * 获取三方外卖地图
   */
  const getRaiderUrl = async () => {
    setDeliveryMapUrl('')
    if (orderMobx.order.eatType === 'delivery' && statusShowName?.length - 2 === viewOrder.currentStatusIndex && viewOrder.deliverInfo) {
      const { isWeixinMiniProgram, isAliPayMiniProgram, inMiniApp } = getPlatform()
      let url = viewOrder.deliverInfo?.trailUrl
      if (url && (isWeixinMiniProgram || isAliPayMiniProgram || inMiniApp)) {
        // url = url.replace(/:\/\//, '/')
        // url = `${ENV.GWPWPROXY}/${url}`
        url = ''
      }
      url && setDeliveryMapUrl(url)
    }
  }

  useEffect(() => {
    if (viewOrder.ordersType === 'dc' && viewOrder.ordersId && viewOrder.storeId && viewOrder.brandId) {
      KitchenAPI.getPickUpCode({
        ordersId: viewOrder.ordersId,
        storeId: viewOrder.storeId,
        brandId: viewOrder.brandId
      }).then((res: any) => {
        if (res.error) {
          setCabinetCode('')
        } else {
          setCabinetCode(res.code || '')
        }
      })
    }
    // 三方外卖地图
    getRaiderUrl()

    // 点餐才把金额明细隐藏
    setShowMorePrice(viewOrder.ordersType !== 'dc')
  }, [viewOrder])

  useEffect(() => {
    if (cabinetCode && barcodeRef.current) {
      JsBarcode(barcodeRef.current, cabinetCode, {
        displayValue: false,
        width: 3,
        height: 64,
        margin: 0,
      })
    }
  }, [cabinetCode, barcodeRef.current])

  /**
   * 分享账单
   */
  const handleShareBill = () => {
    handleShareForWxa({ mode: 'card', scene: 'buyTogetherBill', router: `/billBuyTogether/${viewOrder.ordersId}`, title: i18n.t('menu.buyTogether.billDetail'), imageUrl: 'https://eshine-image.oss-cn-hangzhou.aliyuncs.com/20220407/fe9101efd2c4b8a3.png' })
  }

  /**
   * 重新支付
   */
  const handleRepay = async () => {
    if (!orderMobx.order?.ordersId || viewOrder?.ordersType !== 'dc') return
    const { brandId, storeId, ordersId } = orderMobx.order
    if (!restaurantConfig.storeId || restaurantConfig.storeId !== storeId) {
      restaurantCenter.setConfig({
        storeId: storeId
      })
    }
    await CheckoutPayController.resume(ordersId, true)
    if (ordersId) {
      store.set(`${RestoreOrderController.localKey('prefix')}.${brandId}.${storeId}`, ordersId)
      await RestoreOrderController.restore(true)
    }
    if (isBuyTogether) {
      history.replace('/buyTogetherCart')
    } else {
      history.replace('/checkout')
    }
  }

  /** 餐品列表组件 */
  const productListNode = () => {
    const list = viewDetailList.length > 3 && !showMoreProduct ? viewDetailList.slice(0, 3) : viewDetailList
    return (
      <div className='product-list'>
        {
          list.map((item: any, index: number) => {
            return (
              <div className={classNames('product-item-wrap', { 'is-refund': item.cnt === 0 })} key={`${item.id}_${index}`}>
                {['dc', 'mall'].includes(viewOrder.ordersType) && <ProductImage color={!item.pic ? item.productNo : ''} width={64} imgSrc={item.pic} />}
                {['goods'].includes(viewOrder.ordersType) && !!item.activityType && activityProductImg(item.activityType)}
                <div className='product-content-wrapper'>
                  <div className='product-item'>
                    <div className='name'>
                      <p className='name-txt'>{item.name} {item.cardNo ? item.cardNo : ''} {!!item.isTogo && !['pickup', 'delivery'].includes(viewOrder.eatType) && <BagIcon size='small' />}</p>
                      {!!item.optionHtml && <p className='option-txt' dangerouslySetInnerHTML={{ __html: item.optionHtml }} />}
                      {!!item.remark && (<p className='note'>{i18n.t('common.note')}: {item.remark}</p>)}
                    </div>
                    <div className='amount'>
                      <div className='price'>{toPrice(item.cardType === 'giftcard' ? item.balanceRechargeChange : item.totalPrice)}</div>
                      {item.cnt === 0 ? (<span>{i18n.t('checkout.refunded')}</span>) : ''}
                      <div className='count'>x{item.cnt}</div>
                    </div>
                  </div>
                  {
                    (item.cardType === 'giftcard' || item.cardType === 'card') && (
                      <div className='product-groups'><span className='product-coupon'>{OrdersController.getCardInfo(item)}</span></div>
                    )
                  }
                  {
                    !!item?.productGroups?.length || (viewOrder.eatType === 'redeemCouponByMoney' && couponMap && item?.coupons?.length) ? (
                      <div className='product-groups'>
                        {
                          item.productGroups?.map(group => (
                            <div key={group?.no} className='product-group'>
                              {
                                group?.productGroupDetails.map(product => (
                                  <div key={product.pk} className='product-group-product'>
                                    <div className='name'>
                                      <p>{product.name}</p>
                                      {!!product.optionHtml && <p dangerouslySetInnerHTML={{ __html: product.optionHtml }} />}
                                      {!!product.remark && (<p className='note'>{i18n.t('common.note')}: {product.remark}</p>)}
                                    </div>
                                    <div className='count'>x{product.cnt}</div>
                                  </div>
                                ))
                              }
                            </div>
                          ))
                        }
                        {
                          viewOrder.eatType === 'redeemCouponByMoney' && !item.activityType && !!Object.keys(couponMap)?.length && item.coupons?.map(coupon => {
                            const newItem = couponMap[coupon.couponId]
                            return newItem && (
                              <div key={coupon.couponId} className='product-coupon'>
                                <span>{newItem.couponName} x{coupon.couponCnt}</span>
                              </div>
                            )
                          })
                        }
                        {
                          viewOrder.eatType === 'redeemCouponByMoney' && !!item.activityType && !!Object.keys(couponMap)?.length && map((item?.coupons || []), coupon => {
                            return (
                              <div className='groupbuy-prize-wrap' key={coupon.productName}>
                                <div className='name'>/{coupon.productName}/</div>
                                {
                                  map((coupon?.coupons || []), coupon => {
                                    const newItem = couponMap[coupon.couponId]
                                    return newItem ? (
                                      <div key={coupon.couponId} className='product-coupon'>
                                        <div className='coupon-name'>{newItem.couponName} x{coupon.couponCnt}</div>
                                      </div>
                                    ) : null
                                  })
                                }
                              </div>
                            )
                          })
                        }
                      </div>
                    ) : null
                  }
                  {
                    item.offItems?.map((v: any, index: number) => {
                      return (
                        <div className='discount-item space-between' key={index}>
                          <span className='name'>{v.offType === 'memberPrice' ? i18n.t('result.member_price') : v.offTip}</span>
                          <span className='price'>- {toPrice(v.off)}</span>
                        </div>
                      )
                    })
                  }
                </div>

                {viewDetailList.length > 3 && !showMoreProduct && (
                  <div className='more-btn-wrapper'>
                    <div className='more-btn-wrap' onClick={() => setShowMoreProduct(true)}>
                      <span>{i18n.t('result.moreProdList')}</span>
                      <Icon name='jiantou' />
                    </div>
                  </div>
                )}
              </div>
            )
          })
        }
        {
          !viewDetailList.length && <div className='no-product-txt'>{i18n.t('result.noProducts')}</div>
        }
      </div>
    )
  }

  /** 三方外卖配送地图组件 */
  const deliveryMapNode = (group) => {
    return (
      <div className='delivery-map-wrapper'>
        {
          eatType === 'delivery' && !!deliveryMapUrl && <div className='delivery-map-wrap'><iframe src={deliveryMapUrl} width={document.body.offsetWidth - 16} height='340' style={{ border: 'none' }}></iframe></div>
        }
        <div className='contact-warp'>
          <div className='time-info'>{i18n.t('result.arrivedTime', { time: group?.timeStr })}</div>
          <div className='address-info'>{`${deliverInfo?.deliverys?.[0]?.courierName || ''} `}<a className='courier-tel' href={`tel: ${deliverInfo?.deliverys?.[0].courierMobile}`}>{deliverInfo?.deliverys?.[0].courierMobile}</a></div>
        </div>
      </div>
    )
  }

  /** 餐品预约、外卖等状态 */
  const productStatusNode = (group, index) => {
    const { deliverInfo } = group
    const info = ((deliverInfo?.deliverys || []).filter((delivery: any) => delivery.eventCode === 'orderDelivery.diliverymanPickUp')?.[0] || {}) as any
    const activeStatus = statusShowName[group.currentStatusIndex]

    /** 是否有预约时间 */
    const hasTime = group?.timeStr && ddayjs().valueOf() < ddayjs(group?.startTime).valueOf()
    // 排第一的展示详细，后续的展示缩略状态
    return index === 0 && !!viewOrder.kdsInfo ? (
      <div className='make-groups'>
        {
          eatType !== 'delivery'
            ? (diningMode === 2 ? (
              (statusShowName?.length > 2 || ((viewOrder.acceptTime || viewOrder.addTime) === group?.startTime) ? group?.currentStatusIndex >= statusShowName?.length - 1 : group?.startTime <= ddayjs().format('YYYY-MM-DD HH:mm:ss')) ? (
                <p className='make-send'>{i18n.t('result.product')}{i18n.t(`result.makeStatus.${statusShowName?.[group?.currentStatusIndex || 0] === 'send' ? 'arrived' : statusShowName?.[group?.currentStatusIndex || 0]}`)}</p>
              ) : (
                <p className='make-send'>{((viewOrder.acceptTime || viewOrder.addTime) === group?.startTime) ? `${i18n.t('result.product')}${i18n.t(`result.makeStatus.${statusShowName?.[group?.currentStatusIndex || 0] === 'send' ? 'arrived' : statusShowName?.[group?.currentStatusIndex || 0]}`)}` : i18n.t('result.dineinedTime', { time: group?.timeStr })}</p>
              )
            ) : (
              (statusShowName?.length > 2 || ((viewOrder.acceptTime || viewOrder.addTime) === group?.startTime) ? group?.currentStatusIndex >= statusShowName?.length - 1 : group?.startTime <= ddayjs().format('YYYY-MM-DD HH:mm:ss')) ? (
                <div className='make-pickup'>{statusShowName?.length > 2 ? i18n.t('result.finish') : i18n.t('result.paySuccess')}</div>
              ) : (
                <div className='make-pickup'>{((viewOrder.acceptTime || viewOrder.addTime) === group?.startTime) ? '' : i18n.t('result.pickedTime', { time: group?.timeStr })}</div>
              )
            )) : (
              group?.currentStatusIndex === statusShowName?.length - 1 ? (
                <div className='make-delivery'>{i18n.t('result.finish')}</div>
              ) : (
                <div className='make-delivery'>{((viewOrder.acceptTime || viewOrder.addTime) === group?.startTime) ? '' : i18n.t('result.arrivedTime', { time: group?.timeStr })}</div>
              )
            )
        }
        {
          group?.productsStr ? <div className='make-products'>{group?.productsStr}</div> : null
        }
        <WaitingOrderBar mealsWaitingTime={mealWaitingTime} onRefresh={() => getDelayOrder(id)} />
        {
          eatType !== 'delivery' && !viewOrder.kdsInfo ? null : (
            <div className='make-status'>
              {
                statusShowName?.map((item, index: number) => {
                  const { deliverInfo } = group
                  const info = ((deliverInfo?.deliverys || []).filter((delivery: any) => delivery.eventCode === 'orderDelivery.diliverymanPickUp')?.[0] || {}) as any
                  return (
                    <Fragment key={index}>
                      {
                        item !== 'order' && (
                          <div className={`status-item ${group?.currentStatusIndex === index ? 'active' : ''}`}>
                            {
                              viewOrder.eatType === 'delivery' && info?.courierMobile && info?.courierName && [2, 3].includes(group?.currentStatusIndex) && index === 2 && (
                                <div className='delivery-info'>
                                  <div className='icon-wrapper'>
                                    <a href={`tel: ${info?.courierMobile}`}>
                                      <i className='iconfont icon-store-tel'></i>
                                    </a>
                                    {/* <Icon name='shouji' size={18} className='icon-phone' /> */}
                                  </div>
                                  {info?.courierName}
                                </div>
                              )
                            }
                            <div>
                              <i className={`iconfont ${iconMakeStatus[item]}`}></i>
                              <p>{i18n.t(`result.makeStatus.${item}`)}</p>
                            </div>
                          </div>
                        )
                      }
                      {index !== statusShowName?.length - 1 && index !== 0 && <div className='split'></div>}
                    </Fragment>
                  )
                })
              }
            </div>
          )
        }
      </div>
    ) : (
      <div className='make-groups-thumb'>
        <div className='left-wrap'>
          {
            eatType !== 'delivery'
              ? !viewOrder.kdsInfo ? (
                hasTime ? (
                  <div className='make-pickup'>{i18n.t('result.pickedTime', { time: group?.timeStr })}</div>
                ) : (
                  <div className='make-pickup'>{i18n.t('result.paySuccess')}</div>
                )
              ) : (diningMode === 2 ? (
                (statusShowName?.length > 2 || ((viewOrder.acceptTime || viewOrder.addTime) === group?.startTime) ? group?.currentStatusIndex >= statusShowName?.length - 1 : group?.startTime <= ddayjs().format('YYYY-MM-DD HH:mm:ss')) ? (
                  <p className='make-send'>{i18n.t('result.product')}{i18n.t(`result.makeStatus.${statusShowName?.[group?.currentStatusIndex || 0] === 'send' ? 'arrived' : statusShowName?.[group?.currentStatusIndex || 0]}`)}</p>
                ) : (
                  <p className='make-send'>{((viewOrder.acceptTime || viewOrder.addTime) === group?.startTime) ? `${i18n.t('result.product')}${i18n.t(`result.makeStatus.${statusShowName?.[group?.currentStatusIndex || 0] === 'send' ? 'arrived' : statusShowName?.[group?.currentStatusIndex || 0]}`)}` : i18n.t('result.dineinedTime', { time: group?.timeStr })}</p>
                )
              ) : (
                (statusShowName?.length > 2 || ((viewOrder.acceptTime || viewOrder.addTime) === group?.startTime) ? group?.currentStatusIndex >= statusShowName?.length - 1 : group?.startTime <= ddayjs().format('YYYY-MM-DD HH:mm:ss')) ? (
                  <div className='make-pickup'>{statusShowName?.length > 2 ? i18n.t('result.finish') : i18n.t('result.paySuccess')}</div>
                ) : (
                  <div className='make-pickup'>{((viewOrder.acceptTime || viewOrder.addTime) === group?.startTime) ? '' : i18n.t('result.pickedTime', { time: group?.timeStr })}</div>
                )
              )) : (
                group?.currentStatusIndex === statusShowName?.length - 1 ? (
                  <div className='make-delivery'>{i18n.t('result.finish')}</div>
                ) : (
                  <div className='make-delivery'>{((viewOrder.acceptTime || viewOrder.addTime) === group?.startTime) ? '' : i18n.t('result.arrivedTime', { time: group?.timeStr })}</div>
                )
              )
          }
          {
            group?.productsStr ? <div className='make-products'>{group?.productsStr}</div> : null
          }
        </div>
        {
          eatType !== 'delivery' && !viewOrder.kdsInfo ? hasTime && (
            <div className='make-status'>
              <div className='status-item'>
                <div className='status-wrap'>
                  <p>{i18n.t('result.paySuccess')}</p>
                </div>
              </div>
            </div>
          ) : (
            <div className='make-status'>
              <div className={`status-item ${group?.currentStatusIndex === index ? 'active' : ''}`}>
                {
                  viewOrder.eatType === 'delivery' && info?.courierMobile && info?.courierName && [2, 3].includes(group?.currentStatusIndex) && index === 2 && (
                    <div className='delivery-info'>
                      <div className='icon-wrapper'>
                        <a href={`tel: ${info?.courierMobile}`}>
                          <i className='iconfont icon-store-tel'></i>
                        </a>
                        {/* <Icon name='shouji' size={18} className='icon-phone' /> */}
                      </div>
                      {info?.courierName}
                    </div>
                  )
                }
                <div className='status-wrap'>
                  <i className={`iconfont ${iconMakeStatus[activeStatus]}`}></i>
                  <p>{i18n.t(`result.makeStatus.${activeStatus}`)}</p>
                </div>
              </div>
            </div>
          )
        }
      </div>
    )
  }

  const surchargeDetail = useMemo(() => {
    if (viewOrder.surchargeDetail) {
      const obj: any = {}
      each(viewOrder.surchargeDetail, (item: any) => {
        if (obj[item.name]) {
          obj[item.name].fee += item.fee
        } else {
          obj[item.name] = item
        }
      })
      return values(obj)
    } else {
      return []
    }
  }, [viewOrder.surchargeDetail])

  useEffect(() => {
    if (!WxpayGoldPlanController.isOpen() && viewOrder.status === 'Success' && viewOrder.ordersType !== 'mall') {
      getMealsWaitingTime()
      refundMobx.getMobileRefundPlan()
    }
  }, [viewOrder])
  return (
    <IonPage className='pay-result-page'>
      {
        viewOrder.ordersType === 'mall' ? <ResultMall /> : (
          <>
            <IonContent className='pay-result-content' ref={contentRef}>
              {(!openInGoldPlan || goldPlanBackUrl) ? (
                <div className='back-wrap' onClick={backToPage}><Icon name='BACK-12x' /></div>
              ) : null}
              <div className='pay-result-base'>
                {
                  viewOrder.ordersType === 'dc' && viewOrder.status === 'Success' ? (
                    <div className={classNames('make-info', { hasMap: !!deliveryMapUrl })}>
                      {
                        cabinetCode ? (
                          /* 取餐柜 */
                          <div className='pickup-cabinet'>
                            <div className='bar-area'>
                              <svg className='bar-code' ref={barcodeRef} />
                            </div>
                            <div className='cabinet-des'>
                              <span className='title'>{i18n.t('result.pickupCabinetCode')}</span>
                              <span className='code'>{cabinetCode}</span>
                            </div>
                          </div>
                        ) : (
                          /* 取餐号 */
                          <div className='make-result'>
                            <div className='make-result-pickup'>
                              <p>{i18n.t('result.nono2')}</p>
                              <p className='make-result-nono'>{viewOrder.nono}</p>
                            </div>
                          </div>
                        )
                      }
                      <TableInput />
                      <div className='circle'><div className='dashed'></div></div>
                      {
                        statusGroups?.map((group, idx) => (
                          <Fragment key={idx}>
                            {idx !== 0 && <div className='circle'><div className='dashed'></div></div>}
                            {
                              eatType === 'delivery' && !!deliveryMapUrl && idx === 0 ? (
                                // 三方外卖配送地图
                                deliveryMapNode(group)
                              ) : (
                                productStatusNode(group, idx)
                              )
                            }
                          </Fragment>
                        ))
                      }
                    </div>
                  ) : (
                    <>
                      {
                        !openInGoldPlan ? (
                          isCheckPay ? (
                            <>
                              <div className='result-checking'>
                                <IonSpinner name='dots' />
                              </div>
                            </>
                          ) : (
                            viewOrder?.memberOrder?.groupBuy?.addTime && !viewOrder.ordersRefundList?.length ? (
                              <div className='result-detail-group'>
                                <GroupBuyStatus info={viewOrder}></GroupBuyStatus>
                              </div>
                            ) : (
                              // (viewOrder.eatType as string) !== 'giftcard' &&
                              <div className='result-detail-top'>
                                {!isErrPayForPos && <i className={`iconfont ${iconStatus[viewOrder.status]}`}></i>}
                                <h4>{viewOrder.ordersRefundList?.length ? i18n.t('result.refundSucc') : i18n.t(reason[viewOrder.status])}</h4>
                                {
                                  viewOrder.ordersType === 'cz' ? (
                                    <>
                                      <div className='sub-title'>{i18n.t('result.currentCardBalance')}</div>
                                      <div className='balance'>{toPrice(cardBalance?.balanceAfter)}</div>
                                    </>
                                  ) : <h6>{viewOrder.ordersType === 'dc' ? i18n.t(tips[viewOrder.status]) : i18n.t('result.successTips2')}</h6>
                                }
                                {isErrPayForPos && <div className='last-payment' dangerouslySetInnerHTML={{ __html: lastPayment }}></div>}
                                {isErrPayForPos && <div className='pay-error-txt'>{i18n.t('result.errPayForPosTip')}</div>}
                                {!isErrPayForPos && viewOrder.ordersType === 'dc' && viewOrder.status === 'Paying' && !openInGoldPlan && (<div className='repay' onClick={handleRepay}>{i18n.t('menu.go_pay')}</div>)}
                              </div>
                            )
                          )
                        ) : (
                          viewOrder?.memberOrder?.groupBuy?.addTime && !viewOrder.ordersRefundList?.length ? (
                            <div className='result-detail-group'>
                              <GroupBuyStatus info={viewOrder}></GroupBuyStatus>
                            </div>
                          ) : null
                        )
                      }
                      {
                        viewOrder.ordersType !== 'dc' ? (
                          isCheckPay ? (
                            <div className='result-checking'>
                              <IonSpinner name='dots' />
                            </div>
                          ) : (
                            <div className='result-detail'>
                              <h2>{viewOrder.nono ? `#${viewOrder.nono === '0' ? '' : viewOrder.nono}` : ''}</h2>
                              <h6>{i18n.t(OrdersController.OrderEatType[viewOrder.eatType])}</h6>
                              {
                                viewOrder.ordersRefundList?.length ? (
                                  <p>{i18n.t('result.specialRefund')}</p>
                                ) : viewOrder.status === 'Success' ? <p>{i18n.t('result.specialSuccess')}</p> : null
                              }
                            </div>
                          )
                        ) : null
                      }
                    </>
                  )
                }
                {
                  viewOrder.ordersType === 'dc' ? (
                    <>
                      {
                        eatType === 'delivery' ? (
                          <>
                            <div className='circle'><div className='dashed'></div></div>
                            <div className='contact-warp'>
                              <div>{i18n.t('result.address.sendto')}</div>
                              <div className='address-info'>{contactInfo.shortAddress || contactInfo.address}</div>
                              <div className='contact-info'>{contactName} {contactMobile}</div>
                            </div>
                          </>
                        ) : null
                      }
                      <div className='circle'><div className='dashed'></div></div>
                      <div className='address-wrap space-between'>
                        <div className='address-left'>
                          <img src={storeMobx.brand.logo || Config.defaultImg.logo} />
                          <div className='name'>
                            <p>
                              {viewOrder.store?.storeName}
                            </p>
                            <p className='address'>{viewOrder.store?.address}</p>
                            {viewOrder.tableAlias && <p className='table'>{i18n.t('result.tableAlias')}:  {viewOrder.tableAlias}</p>}
                          </div>
                        </div>
                        <div className='address-right'>
                          {!openInGoldPlan && !!viewOrder.store?.tel ? (
                            <div>
                              <a href={`tel: ${viewOrder.store?.tel}`}>
                                <i className='iconfont icon-store-tel'></i>
                              </a>
                            </div>
                          ) : null}
                          {/* <div onClick={handleMapOpen}>
                            <i className='iconfont icon-store-address'></i>
                          </div> */}
                        </div>
                      </div>
                      {
                        (!openInGoldPlan && viewOrder.status === 'Success' && memberMobx.brandConfig.commentSetting && memberMobx.brandConfig.commentSetting.enable) && (
                          <>
                            <div className='circle'><div className='dashed'></div></div>
                            <div className='notice-wrap'>
                              <div
                                className='btn' onClick={(e: any) => {
                                  e.stopPropagation()
                                  if (viewOrder.memberOrder?.hasComment) {
                                    history.push({
                                      pathname: `/eval/detail/${viewOrder.ordersId}`,
                                    })
                                  } else {
                                    history.push({
                                      pathname: `/eval/${viewOrder.ordersId}`,
                                    })
                                  }
                                }}
                              >
                                {viewOrder.memberOrder?.hasComment ? i18n.t('mkt.comment.viewReviews') : i18n.t('mkt.comment.toEvaluate')}
                              </div>
                            </div>
                          </>
                        )
                      }
                    </>
                  ) : null
                }
              </div>
              {/* 退款状态 */}
              {!!orderMobx.order.ordersId && <RefundBar info={orderMobx.order} />}
              {/* 消费送展示位 */}
              {
                !openInGoldPlan && !!receiveCouponCnt && (
                  <div className='consume-send-coupon'>
                    <i className='iconfont icon-piaoju'></i>
                    <div className='content'>{memberMobx.isMember ? i18n.t('mkt.coupon.getCouponTip2', { num: receiveCouponCnt }) : i18n.t('mkt.coupon.getCouponTip', { num: receiveCouponCnt })}</div>
                    <div
                      className='get-coupon' onClick={() => {
                        if (memberMobx.isMember) {
                          MktController.sendCoupons({ ordersId: id }, history)
                        } else {
                          store.set(memberMobx.consumeCouponsKey, { ordersId: id })
                          MktController.jumpBind(history, 'all')
                        }
                      }}
                    >{i18n.t('mkt.coupon.clickGet')}<i className='iconfont icon-chevron-right'></i>
                    </div>
                  </div>
                )
              }
              {/* 广告展示位 */}
              {!openInGoldPlan && <MenuAdvert type='finish' />}
              {/* 商品列表与费用明细 */}
              <div className='pay-result-detail'>
                <div className='title-wrapper'>{i18n.t('result.mealsInfo')}</div>
                {
                  viewOrder.remark ? (
                    <>
                      <div className='remark'>
                        {i18n.t('common.note')}: {viewOrder.remark}
                      </div>
                      <div className='dashed'></div>
                    </>
                  ) : null
                }
                {/* 商品列表 */}
                {productListNode()}
                <div className='hide-detail'>
                  <div className='dashed'></div>
                  <div className={classNames('pay-more-wrapper', { more: showMorePrice })}>
                    {
                      viewOrder.offItems.map((offItem, index) => (
                        <DetailItem
                          key={index}
                          title={offItem.offTip}
                          content={toPrice(-offItem.off)}
                        />
                      ))
                    }
                    {
                      !!viewOrder.discountIntegralMoneyPrice && (
                        <DetailItem
                          title={i18n.t('result.integralMoney')}
                          content={toPrice(-orderMobx.viewOrder.discountIntegralMoneyPrice)}
                        />
                      )
                    }
                    {
                      !!viewOrder.orderPlanOffItem && (
                        <DetailItem
                          title={orderMobx.viewOrder.orderPlanOffItem.tagId ? orderMobx.viewOrder.orderPlanOffItem.offTip : i18n.t('result.managerDiscount')}
                          content={toPrice(-orderMobx.viewOrder.orderPlanOffItem.off)}
                        />
                      )
                    }
                    <DetailItem
                      title={viewOrder.ordersType === 'dc' ? i18n.t('result.productPrice') : i18n.t('result.goodsPrice')}
                      content={viewOrder.ordersType === 'dc' ? toPrice(viewOrder.itemPrice || 0) : toPrice((viewOrder.totalOriginalPrice || 0) - (viewOrder.surcharge || 0))}
                    />
                    {
                      (viewOrder.eatType === 'delivery' || !!viewOrder.boxPrice) && (
                        <DetailItem
                          title={i18n.t('result.boxPrice')}
                          content={toPrice(viewOrder.boxPrice || 0)}
                        />
                      )
                    }
                    {
                      (viewOrder.eatType === 'delivery' || !!viewOrder.expressPrice) && (
                        <DetailItem
                          title={i18n.t('result.expressPrice')}
                          onMore={() => {
                            modalLayer(ExpressPriceModal, {})
                              .then(() => { })
                              .catch(() => { })
                          }}
                          content={toPrice(viewOrder.expressPrice || 0)}
                        />
                      )
                    }
                    <DetailItem
                      title={i18n.t('result.allDiscount')}
                      content={toPrice(-viewOrder.totalDiscountPrice || 0)}
                    />
                    {
                      bo === 'us' && (
                        <DetailItem
                          title={i18n.t('result.subTotal')}
                          content={toPrice(viewOrder.itemTotalPrice || 0)}
                        />
                      )
                    }
                    {
                      viewOrder.discountFloorPrice > 0 && (
                        <DetailItem
                          title={i18n.t('result.floor')}
                          content={toPrice(-viewOrder.discountFloorPrice || 0)}
                        />
                      )
                    }
                    {
                      surchargeDetail.map((item: any, index: number) => {
                        return (
                          <DetailItem
                            key={index}
                            title={`${item?.name || i18n.t('pay.surcharge.surcharge')}${item?.rate ? `(${item.rate}%)` : ''}`}
                            content={toPrice(item.fee || 0)}
                          />
                        )
                      })
                    }
                    {
                      viewOrder.serviceCharge > 0 && (
                        <DetailItem
                          title={(
                            <Fragment key='serviceCharge'>
                              <span>{viewOrder.serviceChargeGratuityName}</span>
                              <i className='iconfont icon-question'></i>
                            </Fragment>
                          )}
                          content={toPrice(viewOrder.serviceCharge || 0)}
                        />
                      )
                    }
                    {
                      bo === 'us' && viewOrder.tax === 0 && !viewOrder.taxDetail.length && (
                        <DetailItem
                          title={i18n.t('result.tax')}
                          content={toPrice(viewOrder.tax || 0)}
                        />
                      )
                    }
                    {
                      (bo === 'us' && viewOrder.tax > 0) && viewOrder.taxDetail.map((taxItem, index) => {
                        return (
                          <DetailItem
                            key={index}
                            title={`${taxItem.taxCategoryId === -1 ? i18n.t('cart.tax') : taxItem.name || i18n.t('cart.tax')}(${!taxItem.isTaxFree ? taxItem.rate + '%' : 'exempt'})`}
                            content={toPrice(taxItem.amount)}
                          />
                        )
                      })
                    }
                    {
                      viewOrder.showTax > 0 && bo === 'us' && (
                        <DetailItem
                          title={i18n.t('cart.haveTax')}
                          content={toPrice(viewOrder.showTax)}
                        />
                      )
                    }
                    <DetailItem
                      title={i18n.t('result.total')}
                      content={toPrice((viewOrder.totalPriceExcludeTip || 0) + (viewOrder.surcharge || 0))}
                    />
                    <div className='dashed'></div>
                    {
                      viewOrder.tip > 0 && (
                        <DetailItem
                          title={i18n.t('result.tip')}
                          content={toPrice(viewOrder.tip)}
                        />
                      )
                    }
                  </div>
                  {/* 总计 */}
                  <div className='all-total-wrapper'>
                    {
                      viewOrder.ordersType === 'dc' && ['dinein', 'togo'].includes(viewOrder.eatType) && (
                        <span className='txt'>{i18n.t('result.personTotal', { cnt: viewOrder.person + (viewOrder.kids || 0) })}，</span>
                      )
                    }
                    <span className='txt'>{i18n.t('result.alltotal')}</span>
                    <span className='all-total-txt'>{toPrice(Number(viewOrder.totalPrice))}</span>
                    {viewOrder.ordersType === 'dc' && (
                      <div className={classNames('more-btn', { up: showMorePrice })} onClick={() => setShowMorePrice(!showMorePrice)}>
                        <Icon name='chevron-down' />
                      </div>
                    )}
                  </div>
                  {/* 退款金额 */}
                  {
                    viewOrder.ordersType === 'dc' && !!viewOrder.ordersRefundList?.length && (
                      <DetailItem
                        title={i18n.t('result.refund')}
                        content={`-${toPrice(sumBy(filter(viewOrder.ordersRefundList, (item) => item.status === TEOrdersRefundStatus.Success), (n) => n.refundFee))}`}
                      />
                    )
                  }
                </div>
                {
                  !openInGoldPlan && viewOrder.eatType && viewOrder.channel === 'mobile' && canRefundType.includes(viewOrder.eatType) && !viewOrder.ordersRefundList?.length && canRefundGoods && ( // 只有手机上操作的订单（付费会员卡开卡/续费/团购商城）才有退款入口
                    <div className='detail-refund' onClick={getRefund}>
                      <span>{i18n.t('result.refund')}</span>
                      <i className='iconfont icon-chevron-right'></i>
                    </div>
                  )
                }
              </div>
              <div className='pay-result-detail orderInfo'>
                <div className='title-wrapper'>{i18n.t('result.orderInfo')}</div>
                <div className='hide-detail'>
                  {
                    viewOrder.paymentList?.map((pay: any, index: number) => {
                      const { name, cardNo, amountPaid } = payMobx.getPaymentDisplay(pay)
                      return (
                        <Fragment key={pay.paymentId}>
                          {index === 0 && (
                            <DetailItem
                              title={i18n.t('result.payment')}
                            />
                          )}
                          <DetailItem
                            title={name}
                            content={toPrice(amountPaid)}
                          />
                          <DetailItem
                            title={i18n.t('result.cardNumber')}
                            content={`**** ${cardNo?.substring(cardNo.length - 4, cardNo.length)}`}
                            style={{ display: !cardNo ? 'none' : 'flex' }}
                          />
                        </Fragment>
                      )
                    })
                  }
                  <DetailItem
                    dashed title={i18n.t('result.nono2')}
                    content={viewOrder.ordersId}
                  />
                  <DetailItem
                    dashed
                    type='light'
                    title={i18n.t('result.orderTime')}
                    content={toDateTime(viewOrder.addTime)}
                  />
                </div>
              </div>
              {
                viewOrder.ordersType === TEOrdersType.dc && viewOrder.memberOrder && viewOrder.memberOrder.memberType && viewOrder.memberOrder.memberType !== 'member' && (
                  <div className='result-not-member-tip'>
                    <i className='iconfont icon-info'></i>
                    <div className='tip-text'>
                      {i18n.t('order.notMemberTip')}
                    </div>
                  </div>
                )
              }
              {
                canRefund && (
                  <div className='refund-btn' onClick={() => history.push(`/refund/${id}`)}>{i18n.t('refund.refundRequest')}</div>
                )
              }
              {
                showGroupBuyAnimate && (
                  <GroupBuyBox
                    onClose={() => setShowGroupBuyBag(false)}
                    productType={orderMobx.viewDetailList[0].activityType || ''}
                    coupons={orderMobx.viewDetailList?.[0]?.coupons}
                    couponMap={couponMap}
                  />
                )
              }
            </IonContent>
            {
              isBuyTogether && isWeixinMiniProgram && viewOrder.status === 'Success' ? (
                <IonFooter className='pay-result-footer pay-bt'>
                  <div className='share-btn btn btn-single' onClick={handleShareBill}>{i18n.t('menu.buyTogether.shareBill')}</div>
                </IonFooter>
              ) : null
            }
            {
              !isBuyTogether && !isCheckPay && showFooter && !openInGoldPlan ? (
                <IonFooter className='pay-result-footer'>
                  {
                    // viewOrder.sourceType === 'onlineMobileWebH5' &&
                    ((memberMobx.memberInfo.type === 'virtual' || !memberMobx.isLogin) && viewOrder.status === 'Success') ? (
                      <div className='send-email-btn'>
                        {
                          userInfo.value ? (
                            <div className='send-title'>
                              <div className='send-number'>
                                <i className='iconfont icon-send2x'></i>
                                <span>{i18n.t('result.haveSendTips')}{i18n.t(`result.${userInfo.type}`)}: {userInfo.value}</span>
                                <span onClick={sendMsg}>{i18n.t('result.reset')}</span>
                              </div>
                              {
                                toMember ? (
                                  <div className='to-member' onClick={() => toBeMember()}>
                                    <span>{i18n.t('result.toBeMember')}</span>
                                    <i className='iconfont icon-chevron-right'></i>
                                  </div>
                                ) : null
                              }
                            </div>
                          ) : (
                            <>
                              <div className='title'>
                                <i className='iconfont icon-send2x'></i>
                                <span>{i18n.t('result.sendOrderTips')}</span>
                              </div>
                              <div className='content' onClick={() => sendMsg()}>
                                <div className='number-input'>
                                  <span>{userInfo.value || i18n.t('checkout.inputMobileOrEmailLogin')}</span>
                                  <div>{i18n.t('result.send')}</div>
                                </div>
                              </div>
                            </>
                          )
                        }
                      </div>
                    ) : null
                  }
                </IonFooter>
              ) : null
            }
          </>
        )
      }
    </IonPage>
  )
}

export default observer(Result)
